/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_OpenInputs */

const en_common_open = /** @type {(inputs: Common_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open`)
};

const id_common_open = /** @type {(inputs: Common_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka`)
};

/**
* | output |
* | --- |
* | "Open" |
*
* @param {Common_OpenInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const common_open = /** @type {((inputs?: Common_OpenInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_OpenInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_common_open(inputs)
	return en_common_open(inputs)
});